export enum AdminQuestionsTableColumnDataIndex {
  OrdinalNumber = "ordinalNumber",
  Question = "question",
  Options = "options",
}
